import { bemClassBuilder } from '@vista-digital/bem-class-builder'
import { useI18n } from '@vista-digital/occ-ui'
import type { FC } from 'react'

interface CarouselPositionIndicatorProps {
    selected: boolean
    index: number
    onClick: VoidFunction
}

const b = bemClassBuilder('v-carousel-position-indicator')

export const CarouselPositionIndicator: FC<CarouselPositionIndicatorProps> = props => {
    const { selected, index, onClick } = props
    const i18n = useI18n()

    // carouselPositionIndicatorAriaLabel does not exist in OCC v14. A hard coded default value is used instead.
    // const { carouselPositionIndicatorAriaLabel } = useOccAccessibilityText();

    return (
        <button
            className={b.block({ selected })}
            onClick={onClick}
            tabIndex={-1}
            aria-selected={selected}
            aria-label={i18n.template('Slide ${slideNumber}', { slideNumber: index + 1 })}
            type="button"
            role="tab"
        />
    )
}

CarouselPositionIndicator.displayName = 'CarouselPositionIndicator'
